export const contact = {
  // Hero
  heroTitle: 'Get in Touch',
  heroSubtitle: 'Ready to find the right solution for your project? Let\'s talk with our head office in Çorlu.',
  
  // Contact Info
  address: 'Address',
  addressValue: 'Şeyh Sinan, Hüsmen Kalfa Sk. No:5/33, 59850 Çorlu/Tekirdağ',
  phone: 'Phone',
  phoneValue: '+90 530 095 97 41',
  email: 'Email',
  emailValue: 'info@dynamixsteelfiber.com',
  instagram: 'Instagram',
  instagramValue: '@dynamixsteelfiber',
  whatsapp: 'WhatsApp',
  whatsappValue: '+90 530 095 97 41',
  
  // Form
  formTitle: 'Send Us a Message',
  fullName: 'Full Name',
  fullNamePlaceholder: 'John Doe',
  companyName: 'Company Name',
  companyNamePlaceholder: 'ABC Construction',
  emailAddress: 'Email Address',
  emailPlaceholder: 'you@example.com',
  phoneNumber: 'Phone Number',
  phonePlaceholder: '+90 (123) 456-7890',
  message: 'Message',
  messagePlaceholder: 'Tell us about your project requirements...',
  required: '*',
  characters: 'characters',
  sendMessage: 'Send Message',
  sending: 'Sending...',
  
  successMessage: 'Thank you! Your message has been sent successfully. We\'ll get back to you soon.',
  errorMessage: 'Sorry, there was an error sending your message. Please try again or contact us directly.',
  
  // Map
  mapTitle: 'Our Location',
  mapSubtitle: 'Visit our facility in Çorlu, Tekirdağ',
  
  // Business Hours
  hoursTitle: 'Business Hours',
  officeHours: 'Office Hours',
  mondayFriday: 'Monday - Friday:',
  mondayFridayTime: '8:00 AM - 6:00 PM',
  saturday: 'Saturday:',
  saturdayTime: '9:00 AM - 2:00 PM',
  sunday: 'Sunday:',
  sundayTime: 'Closed',
  
  productionFacility: 'Production Facility',
  productionMF: 'Monday - Friday:',
  productionMFTime: '24/7 Operations',
  productionWeekend: 'Weekend:',
  productionWeekendTime: 'On Request',
};
